document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".local-time").forEach(span => {
    const utcString = span.dataset.utc;
    if (!utcString) return;

    const localDate = new Date(utcString);
    const formatted = localDate.toLocaleString(undefined, {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    });

    span.textContent = formatted;
  });
});
// Tue, 29 Apr 2025 12:59 UTC